import { render } from "./AgentiFirmatariDataTable.vue?vue&type=template&id=164e3c68&scoped=true"
import script from "./AgentiFirmatariDataTable.vue?vue&type=script&lang=js"
export * from "./AgentiFirmatariDataTable.vue?vue&type=script&lang=js"

import "./AgentiFirmatariDataTable.vue?vue&type=style&index=0&id=164e3c68&scoped=true&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-164e3c68"]])

export default __exports__